import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { SearchIcon, ArrowRightIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Search = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (query) {
      performSearch(query);
    }
  }, [query]);
  const performSearch = (searchQuery: string) => {
    setIsLoading(true);
    // Simulate search - in a real app, this would query your backend
    setTimeout(() => {
      const mockResults = [{
        title: 'Admissions',
        description: 'Learn about our admission process, requirements, and how to apply to Isonyin Grammar School.',
        path: '/admissions',
        type: 'Page'
      }, {
        title: 'Academic Programs',
        description: 'Explore our comprehensive curriculum and academic offerings.',
        path: '/academics',
        type: 'Page'
      }, {
        title: 'Campus Facilities',
        description: 'Tour our modern facilities including classrooms, laboratories, and sports facilities.',
        path: '/campus',
        type: 'Page'
      }, {
        title: 'Student Life',
        description: 'Discover the vibrant student life at IGS with our boarding facilities, clubs, and activities.',
        path: '/student-life',
        type: 'Page'
      }, {
        title: 'Contact Information',
        description: 'Get in touch with us for any inquiries about the school.',
        path: '/contact',
        type: 'Page'
      }].filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()) || item.description.toLowerCase().includes(searchQuery.toLowerCase()));
      setResults(mockResults);
      setIsLoading(false);
    }, 500);
  };
  return <div className="min-h-screen bg-white" data-id="element-6534">
      <PageHeader title="Search Results" description={`Showing results for "${query}"`} backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Search',
      path: '/search'
    }]} data-id="element-6535" />
      <div className="container mx-auto px-4 py-12" data-id="element-6536">
        <div className="max-w-4xl mx-auto" data-id="element-6537">
          <div className="mb-8" data-id="element-6538">
            <div className="flex items-center justify-between mb-4" data-id="element-6539">
              <h2 className="text-2xl font-bold text-blue-900" data-id="element-6540">
                {isLoading ? 'Searching...' : `${results.length} results found`}
              </h2>
            </div>
          </div>
          {isLoading ? <div className="text-center py-12" data-id="element-6541">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900" data-id="element-6542"></div>
              <p className="mt-4 text-gray-600" data-id="element-6543">Searching...</p>
            </div> : results.length > 0 ? <div className="space-y-6" data-id="element-6544">
              {results.map((result, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow" data-id="element-6545">
                  <div className="flex items-start justify-between mb-2" data-id="element-6546">
                    <h3 className="text-xl font-bold text-blue-900 hover:text-blue-700" data-id="element-6547">
                      <Link to={result.path} data-id="element-6548">{result.title}</Link>
                    </h3>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded" data-id="element-6549">
                      {result.type}
                    </span>
                  </div>
                  <p className="text-gray-700 mb-4" data-id="element-6550">{result.description}</p>
                  <Link to={result.path} className="inline-flex items-center text-blue-700 hover:text-blue-900 font-medium" data-id="element-6551">
                    View Page <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-6552" />
                  </Link>
                </div>)}
            </div> : <div className="text-center py-12 bg-gray-50 rounded-lg" data-id="element-6553">
              <SearchIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" data-id="element-6554" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6555">
                No results found
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-6556">
                We couldn't find any results for "{query}". Try searching with
                different keywords.
              </p>
              <Button href="/" variant="primary" data-id="element-6557">
                Return to Home
              </Button>
            </div>}
        </div>
      </div>
    </div>;
};
export default Search;